import { forwardRef } from 'react';

import {
  Grid,
  Input,
  PinInput as MantinePinInput,
  PinInputProps as MantinePinInputProps,
  useMantineColorScheme
} from '@mantine/core';

interface PinInputProps extends MantinePinInputProps {
  label?: string;
  description?: string;
}

const PinInput = forwardRef<HTMLInputElement, PinInputProps>(
  ({ label, description, size, ...rest }, ref) => {
    const scheme = useMantineColorScheme();
    return (
      <Grid gutter={0}>
        {(label || description) && (
          <Grid.Col span={12} mb={0}>
            {label && (
              <Input.Label
                fw={400}
                styles={(theme) => ({
                  label: {
                    color:
                      scheme.colorScheme === 'light'
                        ? theme.colors.text[4]
                        : undefined
                  }
                })}
                size={size}
              >
                {label}
              </Input.Label>
            )}
            {description && (
              <Input.Description size={size}>{description}</Input.Description>
            )}
          </Grid.Col>
        )}
        <Grid.Col span={12}>
          <MantinePinInput ref={ref} {...rest} size={size} />
        </Grid.Col>
      </Grid>
    );
  }
);

export { PinInput };
